/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_DemoteInputs */

const en_action_demote = /** @type {(inputs: Action_DemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demote to Member`)
};

const es_action_demote = /** @type {(inputs: Action_DemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Degradar a Miembro`)
};

const fr_action_demote = /** @type {(inputs: Action_DemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rétrograder en Membre`)
};

const de_action_demote = /** @type {(inputs: Action_DemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Mitglied herabstufen`)
};

const id_action_demote = /** @type {(inputs: Action_DemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turunkan ke Anggota`)
};

/** @type {(inputs: Action_DemoteInputs) => LocalizedString} */
const ja_action_demote = en_action_demote;

/** @type {(inputs: Action_DemoteInputs) => LocalizedString} */
const zh_action_demote = en_action_demote;

/** @type {(inputs: Action_DemoteInputs) => LocalizedString} */
const ar_action_demote = en_action_demote;

/** @type {(inputs: Action_DemoteInputs) => LocalizedString} */
const it_action_demote = en_action_demote;

/** @type {(inputs: Action_DemoteInputs) => LocalizedString} */
const ru_action_demote = en_action_demote;

/** @type {(inputs: Action_DemoteInputs) => LocalizedString} */
const pt_action_demote = en_action_demote;

/** @type {(inputs: Action_DemoteInputs) => LocalizedString} */
const ko_action_demote = en_action_demote;

/**
* | output |
* | --- |
* | "Demote to Member" |
*
* @param {Action_DemoteInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_demote = /** @type {((inputs?: Action_DemoteInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_DemoteInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_demote(inputs)
	if (locale === "es") return es_action_demote(inputs)
	if (locale === "fr") return fr_action_demote(inputs)
	if (locale === "de") return de_action_demote(inputs)
	if (locale === "ja") return ja_action_demote(inputs)
	if (locale === "zh") return zh_action_demote(inputs)
	if (locale === "ar") return ar_action_demote(inputs)
	if (locale === "id") return id_action_demote(inputs)
	if (locale === "it") return it_action_demote(inputs)
	if (locale === "ru") return ru_action_demote(inputs)
	if (locale === "pt") return pt_action_demote(inputs)
	return ko_action_demote(inputs)
});